import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import type { FutureReservationsScope } from "@/hooks/useStayPlanContractConfig";

export interface FutureReservationsScopeFieldProps {
  value: FutureReservationsScope;
  onChange: (value: FutureReservationsScope) => void;
  /** Diárias avulsas futuras que usam o plano. */
  linkedCount: number;
}

/**
 * Pergunta o destino das reservas futuras ao pausar ou cancelar um plano de
 * creche. Só aparece quando existe alguma avulsa ligada ao plano.
 */
export function FutureReservationsScopeField({ value, onChange, linkedCount }: FutureReservationsScopeFieldProps) {
  const { t } = useTranslation("patients");
  const id = useId();

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="text-sm font-semibold text-foreground">{t("stayPlanConfig.futureScope.title")}</legend>
      <p className="text-xs text-muted-foreground">
        {t("stayPlanConfig.futureScope.hint", { count: linkedCount })}
      </p>
      <RadioGroup value={value} onValueChange={(next) => onChange(next as FutureReservationsScope)} className="gap-2">
        <div className="flex items-center gap-2">
          <RadioGroupItem id={`${id}-plan`} value="plan" />
          <Label htmlFor={`${id}-plan`}>{t("stayPlanConfig.futureScope.plan")}</Label>
        </div>
        <div className="flex items-center gap-2">
          <RadioGroupItem id={`${id}-all`} value="all" />
          <Label htmlFor={`${id}-all`}>{t("stayPlanConfig.futureScope.all")}</Label>
        </div>
      </RadioGroup>
    </fieldset>
  );
}
